module.exports = __webpack_public_path__ + "img/hnhk.0fc1446f.jpeg";